/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_FutureInputs */

const en_us2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That time hasn't come yet.`)
};

const pt_br2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse horário ainda não chegou.`)
};

const es_419_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa hora todavía no llegó.`)
};

const pt_pt2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa hora ainda não chegou.`)
};

const fr_fr2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette heure n'est pas encore arrivée.`)
};

const de_de2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Uhrzeit ist noch nicht erreicht.`)
};

const it_it2_workout_quick_future = /** @type {(inputs: Workout_Quick_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'ora non è ancora arrivata.`)
};

/**
* | output |
* | --- |
* | "That time hasn't come yet." |
*
* @param {Workout_Quick_FutureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_future = /** @type {((inputs?: Workout_Quick_FutureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_FutureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_future(inputs)
	if (locale === "es-419") return es_419_workout_quick_future(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_future(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_future(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_future(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_future(inputs)
	return en_us2_workout_quick_future(inputs)
});
export { workout_quick_future as "workout-quick.future" }